import { useState, useEffect } from "react";
import Left from "src/components/organisms/side-bars/Left";
import Right from "src/components/organisms/side-bars/Right";
import Portfolio from "src/components/organisms/Portfolio";
import Graph from "src/components/organisms/Graph";
import TopAgent from "src/components/organisms/TopAgent";
import TopAgentSlider from "src/components/organisms/TopAgentSlider";
import TopProduct from "src/components/organisms/TopProduct";
import TopProductSlider from "src/components/organisms/TopProductSlider";
import { useSelector } from "react-redux";

const Dashboard = () => {
  const [show, setShow] = useState(false);
  const [hideMenu, setHideMenu] = useState(true);
  const products = useSelector((state) => state.global.products);
  const agents = useSelector((state) => state.global.agents);

  const handleShowMenu = () => {
    setHideMenu(false);
    setTimeout(() => {
      setShow(true);
    }, 50);
  };
  const handleBackMenu = () => {
    setShow(false);
    setTimeout(() => {
      setHideMenu(true);
    }, 400);
  };

  const handleResize = () => {
    setHideMenu(window.innerWidth < 1280);
    setShow(window.innerWidth >= 1280);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div className="grid grid-cols-1 xl:grid-cols-5">
        {!hideMenu && (
          <div
            className={`sticky top-0 h-screen z-40 transition-transform duration-500 ease-in-out transform bg-white ${
              show ? "translate-x-0" : "-translate-x-full"
            } md:block md:translate-x-0`}>
            <Left />
          </div>
        )}
        <div
          className={`${
            !hideMenu ? "col-span-1 md:col-span-3" : "col-span-1 md:col-span-4"
          } transition-all duration-500 ease-in-out px-6 xl:px-16 pt-8 bg-white`}>
          <h3 className="text-light-black font-bold text-3xl">Dashboard</h3>
          <div className="text-light-gray text-lg font-bold mb-8 md:mb-16">
            {`Today's`} date: Sun, 10 April 2022
          </div>
          <Portfolio />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-10">
            <div className="col-span-1 md:col-span-2">
              <div>
                <Graph />
              </div>
              <div className="hidden md:block mt-10">
                <TopProduct products={products} />
              </div>
            </div>
            <div className="hidden md:block col-span-1 md:col-span-1">
              <TopAgent agents={agents} />
            </div>
          </div>
        </div>
        <div className="block md:hidden w-full bg-white pt-6">
          <TopProductSlider products={products} />
        </div>
        <div className="block md:hidden w-full bg-white pt-6">
          <TopAgentSlider agents={agents} />
        </div>
        <Right />
      </div>
      <button
        onClick={show ? handleBackMenu : handleShowMenu}
        className="fixed xl:hidden bottom-6 right-6 z-50 bg-black text-white rounded-full h-16 w-16 shadow-xl">
        {show ? "Back" : "Menu"}
      </button>
    </>
  );
};

export default Dashboard;
